import React from 'react';
import S1 from './s1';

function App() {
  return <S1 />;
}

export default App;
